/**
 * @fileoverview Pantone Colors Database
 * Comprehensive database of Pantone colors for the color picker
 */

export interface PantoneColor {
  name: string;
  hex: string;
  pantone: string;
  category?: string;
}

export const PANTONE_COLORS: PantoneColor[] = [
  // Blues
  { name: 'PANTONE 286 C', hex: '#003DA5', pantone: 'PANTONE 286 C', category: 'Blue' },
  { name: 'PANTONE 3005 C', hex: '#004B87', pantone: 'PANTONE 3005 C', category: 'Blue' },
  { name: 'PANTONE 300 C', hex: '#0052CC', pantone: 'PANTONE 300 C', category: 'Blue' },
  { name: 'PANTONE 299 C', hex: '#0072CE', pantone: 'PANTONE 299 C', category: 'Blue' },
  { name: 'PANTONE 298 C', hex: '#0066CC', pantone: 'PANTONE 298 C', category: 'Blue' },
  { name: 'PANTONE 297 C', hex: '#0052CC', pantone: 'PANTONE 297 C', category: 'Blue' },
  { name: 'PANTONE 285 C', hex: '#003DA5', pantone: 'PANTONE 285 C', category: 'Blue' },
  { name: 'PANTONE 284 C', hex: '#003DA5', pantone: 'PANTONE 284 C', category: 'Blue' },
  { name: 'PANTONE 283 C', hex: '#003DA5', pantone: 'PANTONE 283 C', category: 'Blue' },
  { name: 'PANTONE 282 C', hex: '#003DA5', pantone: 'PANTONE 282 C', category: 'Blue' },

  // Reds
  { name: 'PANTONE 186 C', hex: '#C5282F', pantone: 'PANTONE 186 C', category: 'Red' },
  { name: 'PANTONE 200 C', hex: '#C8102E', pantone: 'PANTONE 200 C', category: 'Red' },
  { name: 'PANTONE 485 C', hex: '#DA020E', pantone: 'PANTONE 485 C', category: 'Red' },
  { name: 'PANTONE 201 C', hex: '#B71C1C', pantone: 'PANTONE 201 C', category: 'Red' },
  { name: 'PANTONE 199 C', hex: '#D50000', pantone: 'PANTONE 199 C', category: 'Red' },
  { name: 'PANTONE 187 C', hex: '#B71C1C', pantone: 'PANTONE 187 C', category: 'Red' },
  { name: 'PANTONE 185 C', hex: '#D32F2F', pantone: 'PANTONE 185 C', category: 'Red' },
  { name: 'PANTONE 183 C', hex: '#E53935', pantone: 'PANTONE 183 C', category: 'Red' },
  { name: 'PANTONE 181 C', hex: '#D32F2F', pantone: 'PANTONE 181 C', category: 'Red' },
  { name: 'PANTONE 179 C', hex: '#E53935', pantone: 'PANTONE 179 C', category: 'Red' },

  // Greens
  { name: 'PANTONE 355 C', hex: '#009639', pantone: 'PANTONE 355 C', category: 'Green' },
  { name: 'PANTONE 347 C', hex: '#00B04F', pantone: 'PANTONE 347 C', category: 'Green' },
  { name: 'PANTONE 348 C', hex: '#00A651', pantone: 'PANTONE 348 C', category: 'Green' },
  { name: 'PANTONE 349 C', hex: '#00B04F', pantone: 'PANTONE 349 C', category: 'Green' },
  { name: 'PANTONE 350 C', hex: '#00A651', pantone: 'PANTONE 350 C', category: 'Green' },
  { name: 'PANTONE 351 C', hex: '#00A651', pantone: 'PANTONE 351 C', category: 'Green' },
  { name: 'PANTONE 352 C', hex: '#00A651', pantone: 'PANTONE 352 C', category: 'Green' },
  { name: 'PANTONE 353 C', hex: '#00A651', pantone: 'PANTONE 353 C', category: 'Green' },
  { name: 'PANTONE 354 C', hex: '#00A651', pantone: 'PANTONE 354 C', category: 'Green' },
  { name: 'PANTONE 356 C', hex: '#00A651', pantone: 'PANTONE 356 C', category: 'Green' },

  // Yellows
  { name: 'PANTONE 109 C', hex: '#FFD100', pantone: 'PANTONE 109 C', category: 'Yellow' },
  { name: 'PANTONE 116 C', hex: '#FFED4A', pantone: 'PANTONE 116 C', category: 'Yellow' },
  { name: 'PANTONE 102 C', hex: '#FFE135', pantone: 'PANTONE 102 C', category: 'Yellow' },
  { name: 'PANTONE 95 C', hex: '#FFD700', pantone: 'PANTONE 95 C', category: 'Yellow' },
  { name: 'PANTONE 88 C', hex: '#FFC107', pantone: 'PANTONE 88 C', category: 'Yellow' },
  { name: 'PANTONE 81 C', hex: '#FFB300', pantone: 'PANTONE 81 C', category: 'Yellow' },
  { name: 'PANTONE 74 C', hex: '#FFA000', pantone: 'PANTONE 74 C', category: 'Yellow' },
  { name: 'PANTONE 67 C', hex: '#FF8F00', pantone: 'PANTONE 67 C', category: 'Yellow' },
  { name: 'PANTONE 60 C', hex: '#FF6F00', pantone: 'PANTONE 60 C', category: 'Yellow' },
  { name: 'PANTONE 53 C', hex: '#FF5722', pantone: 'PANTONE 53 C', category: 'Yellow' },

  // Purples
  { name: 'PANTONE 2685 C', hex: '#6A1B9A', pantone: 'PANTONE 2685 C', category: 'Purple' },
  { name: 'PANTONE 2597 C', hex: '#7B1FA2', pantone: 'PANTONE 2597 C', category: 'Purple' },
  { name: 'PANTONE 2507 C', hex: '#8E24AA', pantone: 'PANTONE 2507 C', category: 'Purple' },
  { name: 'PANTONE 2417 C', hex: '#9C27B0', pantone: 'PANTONE 2417 C', category: 'Purple' },
  { name: 'PANTONE 2327 C', hex: '#AB47BC', pantone: 'PANTONE 2327 C', category: 'Purple' },
  { name: 'PANTONE 2237 C', hex: '#BA68C8', pantone: 'PANTONE 2237 C', category: 'Purple' },
  { name: 'PANTONE 2147 C', hex: '#C9A9DD', pantone: 'PANTONE 2147 C', category: 'Purple' },
  { name: 'PANTONE 2057 C', hex: '#D8B4E8', pantone: 'PANTONE 2057 C', category: 'Purple' },
  { name: 'PANTONE 1967 C', hex: '#E7C6F3', pantone: 'PANTONE 1967 C', category: 'Purple' },
  { name: 'PANTONE 1877 C', hex: '#F6D7FE', pantone: 'PANTONE 1877 C', category: 'Purple' },

  // Oranges
  { name: 'PANTONE 1665 C', hex: '#FF5722', pantone: 'PANTONE 1665 C', category: 'Orange' },
  { name: 'PANTONE 1585 C', hex: '#FF7043', pantone: 'PANTONE 1585 C', category: 'Orange' },
  { name: 'PANTONE 1505 C', hex: '#FF8A65', pantone: 'PANTONE 1505 C', category: 'Orange' },
  { name: 'PANTONE 1425 C', hex: '#FFAB91', pantone: 'PANTONE 1425 C', category: 'Orange' },
  { name: 'PANTONE 1345 C', hex: '#FFCCBC', pantone: 'PANTONE 1345 C', category: 'Orange' },
  { name: 'PANTONE 1265 C', hex: '#FFEDE7', pantone: 'PANTONE 1265 C', category: 'Orange' },
  { name: 'PANTONE 1185 C', hex: '#FF6F00', pantone: 'PANTONE 1185 C', category: 'Orange' },
  { name: 'PANTONE 1105 C', hex: '#FF8F00', pantone: 'PANTONE 1105 C', category: 'Orange' },
  { name: 'PANTONE 1025 C', hex: '#FFA000', pantone: 'PANTONE 1025 C', category: 'Orange' },
  { name: 'PANTONE 945 C', hex: '#FFB300', pantone: 'PANTONE 945 C', category: 'Orange' },

  // Grays
  { name: 'PANTONE Cool Gray 11 C', hex: '#53565A', pantone: 'PANTONE Cool Gray 11 C', category: 'Gray' },
  { name: 'PANTONE Cool Gray 9 C', hex: '#75787B', pantone: 'PANTONE Cool Gray 9 C', category: 'Gray' },
  { name: 'PANTONE Cool Gray 7 C', hex: '#97999B', pantone: 'PANTONE Cool Gray 7 C', category: 'Gray' },
  { name: 'PANTONE Cool Gray 5 C', hex: '#B9BBBD', pantone: 'PANTONE Cool Gray 5 C', category: 'Gray' },
  { name: 'PANTONE Cool Gray 3 C', hex: '#DBDDDF', pantone: 'PANTONE Cool Gray 3 C', category: 'Gray' },
  { name: 'PANTONE Cool Gray 1 C', hex: '#F7F8F9', pantone: 'PANTONE Cool Gray 1 C', category: 'Gray' },
  { name: 'PANTONE Warm Gray 11 C', hex: '#5C5855', pantone: 'PANTONE Warm Gray 11 C', category: 'Gray' },
  { name: 'PANTONE Warm Gray 9 C', hex: '#7A7570', pantone: 'PANTONE Warm Gray 9 C', category: 'Gray' },
  { name: 'PANTONE Warm Gray 7 C', hex: '#98938C', pantone: 'PANTONE Warm Gray 7 C', category: 'Gray' },
  { name: 'PANTONE Warm Gray 5 C', hex: '#B6B0A8', pantone: 'PANTONE Warm Gray 5 C', category: 'Gray' },

  // Blacks and Whites
  { name: 'PANTONE Black C', hex: '#000000', pantone: 'PANTONE Black C', category: 'Black' },
  { name: 'PANTONE Process Black C', hex: '#000000', pantone: 'PANTONE Process Black C', category: 'Black' },
  { name: 'PANTONE White C', hex: '#FFFFFF', pantone: 'PANTONE White C', category: 'White' },
  { name: 'PANTONE Process White C', hex: '#FFFFFF', pantone: 'PANTONE Process White C', category: 'White' },
];

/**
 * Search colors by term
 */
export const searchPantoneColors = (searchTerm: string): PantoneColor[] => {
  if (!searchTerm.trim()) {
    return PANTONE_COLORS;
  }

  const term = searchTerm.toLowerCase();
  return PANTONE_COLORS.filter(
    (color) =>
      color.name.toLowerCase().includes(term) ||
      color.pantone.toLowerCase().includes(term) ||
      color.hex.toLowerCase().includes(term) ||
      (color.category && color.category.toLowerCase().includes(term))
  );
};

/**
 * Get colors by category
 */
export const getColorsByCategory = (category: string): PantoneColor[] => {
  return PANTONE_COLORS.filter((color) => color.category === category);
};

/**
 * Get all available categories
 */
export const getCategories = (): string[] => {
  const categories = new Set(
    PANTONE_COLORS
      .map((color) => color.category)
      .filter((category): category is string => Boolean(category))
  );
  return Array.from(categories).sort();
};
